import type { MaterialModel } from '@/types/material.types';
import { apiClient } from './client';

export const materialsApi = {
  /** GET /materials - the whole catalog, sorted by name. Server-cached, so cheap to re-request. */
  getAll: async (): Promise<MaterialModel[]> => {
    const { data } = await apiClient.get<MaterialModel[]>('/materials');
    return data;
  },
};
